module.exports = __webpack_public_path__ + "static/media/jenkins.61e03d19.png";